import React from "react";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

interface DashboardCardProps {
  name?: string;
  det?: number;
  Icon?: any;
  gradient?: string;
}

const DashboardCard: React.FC<DashboardCardProps> = ({
  name,
  det,
  Icon,
  gradient = "from-primary to-primaryLight",
}) => {
  return (
    <div className="rounded-2xl shadow-lg border p-6 hover:shadow-xl transition-all duration-300 bg-white border-slate-100 shadow-slate-200/50 dark:bg-slate-800 dark:border-slate-700 dark:shadow-slate-900/50">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium mb-1 text-slate-500 dark:text-slate-400">{name}</p>
          <p className="text-3xl font-bold text-slate-800 dark:text-slate-100">{det?.toLocaleString()}</p>
          <div className="flex items-center gap-1 mt-2">
            <div className="flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-emerald-50 text-emerald-600 dark:bg-emerald-900/30 dark:text-emerald-400 dark:border dark:border-emerald-800/50">
              <TrendingUpIcon sx={{ fontSize: 14 }} />
              <span>{det}%</span>
            </div>
            <span className="text-xs text-slate-400 dark:text-slate-500">vs last month</span>
          </div>
        </div>
        <div
          className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${gradient} flex items-center justify-center shadow-lg`}
        >
          {Icon && <Icon className="text-white" sx={{ fontSize: 28 }} />}
        </div>
      </div>
    </div>
  );
};

export default DashboardCard;
